import { useTranslation } from "react-i18next";
import { IconAlertCircle } from "@tabler/icons-react";
import { useMySubscription } from "../hooks/useMySubscription";
import { SubscriptionStatusCard } from "./SubscriptionStatusCard";
import { PaymentHistoryList } from "./PaymentHistoryList";

export function SubscriptionSection() {
  const { t } = useTranslation(undefined, { keyPrefix: "subscription" });
  const { data, isLoading } = useMySubscription();

  const isPastDue = data?.status === "past_due";
  const isClosed = data?.status === "cancelled" || data?.status === "expired";

  return (
    <section aria-labelledby="subscription-section-title" className="grid gap-4">
      <div>
        <h2 id="subscription-section-title" className="text-[15.5px] font-semibold text-ink">
          {t("section.title")}
        </h2>
        <p className="text-[12.5px] text-ink-muted">{t("section.subtitle")}</p>
      </div>

      {isPastDue && (
        <div
          role="alert"
          className="flex items-start gap-2 rounded-xl border border-warning-soft bg-warning-soft/50 px-3 py-2.5"
        >
          <IconAlertCircle size={16} className="mt-0.5 shrink-0 text-warning-ink" aria-hidden />
          <p className="text-[13px] text-warning-ink">{t("section.pastDueBanner")}</p>
        </div>
      )}

      {isClosed && (
        <div
          role="status"
          className="flex items-start gap-2 rounded-xl border border-border bg-bg/40 px-3 py-2.5"
        >
          <IconAlertCircle size={16} className="mt-0.5 shrink-0 text-ink-muted" aria-hidden />
          <p className="text-[13px] text-ink-muted">
            {t(`section.${data?.status === "expired" ? "expiredBanner" : "cancelledBanner"}`)}
          </p>
        </div>
      )}

      <SubscriptionStatusCard data={data} isLoading={isLoading} />
      <PaymentHistoryList pastDue={isPastDue} />
    </section>
  );
}
